import React from 'react'

export interface Area {
  id: string
  name: string
  selected: boolean
}

type AreaListProps = {
  className?: string
  data: Area[]
  onClick: (item: Area) => void
  labelPrefix?: string
}

function AreaList({
  data,
  onClick,
  className = '',
  labelPrefix = '',
}: AreaListProps) {
  const handleClick = React.useCallback(
    (property: Area) => () => {
      onClick(property)
    },
    [onClick]
  )

  return (
    <div className={`w-full ${className}`}>
      <div className="custom-scrollbar flex h-full flex-col gap-[15px] overflow-y-auto">
        {data.map((item) => (
          <button
            key={item.id}
            className="cursor-pointer rounded-lg bg-gradient text-neutralColour"
            onClick={handleClick(item)}
            type="button"
          >
            <div className="flex h-full w-full flex-col gap-3 px-8 py-6">
              <div className="flex w-full items-center justify-between">
                <p className="m-0 text-[41px] font-medium leading-none">
                  {`${labelPrefix}${item.name}`}
                </p>
                <div className="flex h-[25px] w-[25px] items-center justify-center rounded-md bg-neutralColour">
                  {item.selected ? (
                    <div className="h-[17px] w-[17px] rounded-md bg-gradient" />
                  ) : null}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default AreaList
